/**
 * Landing page phone + coins animation.
 *
 * @remarks
 * Implemented with Lottie Files package since all animations are imported from Lottie.
 */

import React from "react";
import { Box, Heading, Stack } from "@chakra-ui/react";
import { Player } from "@lottiefiles/react-lottie-player";

const AnimatedPhone = React.memo(() => {
  return (
    <Stack
      direction={{
        base: "column-reverse",
        lg: "row",
      }}
      alignItems="center"
      w="full"
      justifyContent="center"
      px={[4, 10, 20, 32]}
      gap={[0, 4, 12]}
      className="!my-0 md:!my-8"
      // gap="2rem"
    >
      <Player
        autoplay={true}
        loop={true}
        style={{ height: "500px" }}
        src="https://assets6.lottiefiles.com/packages/lf20_ikaawl5v.json"
      />
      <Box w={["90%", "90%", "90%", "25%"]}>
        <Heading
          as="h2"
          color="teal.900"
          fontSize={32}
          fontWeight="700"
          textAlign={{
            base: "center",
            lg: "initial",
          }}
        >
          Earn $20 in 30 minutes or less
        </Heading>
      </Box>
    </Stack>
  );
});

AnimatedPhone.displayName = "AnimatedPhone";

export default AnimatedPhone;
